module.exports = __webpack_public_path__ + "media/components/NewAsset/icons/insurance-illness-1e48bd09e65138d3dde7089f4c31f2b3.svg";